import { PaymentStatusEnum } from '../../enums';
import { GetPaymentsPayload, Payment } from '../../models/crm/types';
import {
  CreateCardTransferSuccessResponse,
  GetCardTransferStatusSuccessResponse,
  TransferFailResponse,
} from '../../models/payment/types';
import { NullableNumber } from '../../util/types';

export type GetSolanaPaymentsPayload = {
  statuses?: PaymentStatusEnum[]
  pageSize?: number
}

export enum PaymentCall {
  cashCalculated,
  getAvailableCash,
  getOwnerTradingAccounts,
  getPayments,
  getPaymentsAll,
  getSolanaPayments,
  getIndividualLinkedAccounts,
  registerLinkedAccount,
  registerCryptoLinkedAccount,
  registerWithdrawalRequest,
  registerCryptoWithdrawalRequest,
  /**
   * aka Create Bank Deposit Transfer
   * aka Bank Deposit Transaction
   */
  /**
   * aka Create Card Deposit Transfer (Card Deposit Transaction)
   */
  getCardTransferStatus,
  getCryptoRate,
}

export type TransactionsState = {
  data: Payment[];
  filteredOut: Payment[];
  ignored: Payment[];
  // extraData: ExtraPaymentData;
  pageSize: number;
  orderColumn: string;
  orderAscending: boolean;
  isAllTransactionsCall?: boolean;
  callsInQueue: GetPaymentsPayload[];
}

export type LastCardTransferType = {
  amount: number;
  // create card transfer
  createTransferData?: CreateCardTransferSuccessResponse
  statusCheckData?: GetCardTransferStatusSuccessResponse
  transferFailedData?: TransferFailResponse
}

export type WebLastPaymentCache = {
  amount?: NullableNumber
  payment_reference?: string
}

export type RegisterLinkedAccountPayload = {
  /**
  * The format of `file` is native and not used directly in TypeScript.
  * For example Web uses FileReader and Mobile the library `react-native-blob-util` which generates the type within native code.
  * The `file` type is not used in the TypeScript world.
  */
  file?: any
} & BankAccountDetails;

export type RegisterCryptoLinkedAccountPayload = {
  cryptoWalletAddress: string;
  cryptoCode: string;
  cryptoNetworkCode: string;
};

export type BankAccountDetails = {
  iban: string
  bankName: string
  swiftCode: string
  currencyCode: string
  bankCountryId: string
  bankAddress?: string;
}

export type RefreshPaymentsPayload = Partial<Record<PaymentCall, boolean>>
